var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:({
    fontSize: _vm.fontSize,
    fontWeight: _vm.isStrong ? 'bold' : 'normal',
    backgroundColor: _vm.background,
    padding: _vm.padding,
  })},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.hasComma)?_c('span',[_vm._v(",")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }